import axios from "axios";
import setAuthToken from "../../utils/setAuthToken";
import {baseUrl} from '../../config.js';
import { jwtDecode } from "jwt-decode";
import {
    SET_USER,
    CLEAR_USER
    
} from "./types";
// Register User
var jwt_decode = jwtDecode;


export const loginUser = userData => dispatch => {
    return new Promise(function(resolve,reject) {
        console.log('the userdata on ligon is',userData)
    var decoded = jwt_decode(userData.access_token)
    localStorage.setItem("toutadminlogin",JSON.stringify({access_token:userData.access_token,refresh_token:userData.refresh_token}))
        console.log('WE SET LOCAL TO',localStorage.getItem("toutadminlogin"))

    setAuthToken(userData.access_token);
    dispatch(setCurrentUser({
        user:decoded,
        access_token:userData.access_token,
        refresh_token:userData.refresh_token
    }))
  })
};

const setCurrentUser = (data) => {
    return {
        type:'SET_USER',
        payload:data
    }
}

export const clearUser = () => {
    return {
        type:'CLEAR_USER'
    }
}

export const logoutUser = () => dispatch => {
    // Remove token from local storage
    console.log('RUNNING A LOGOUT USER!!!')
    localStorage.removeItem("toutadminlogin");
    // Remove auth header for future requests
    setAuthToken(false);
    dispatch(clearUser())
    // Set current user to empty object {} which will set isAuthenticated to false
    dispatch(setCurrentUser({}));
  };